import { API } from "@/App";

export const ws = async (path, { method = "GET", body } = {}) => {
  const token = localStorage.getItem("crm_auth_token");
  const res = await fetch(`${API}${path}`, {
    method,
    headers: { Authorization: `Bearer ${token}`, ...(body ? { "Content-Type": "application/json" } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (res.status === 401) {
    localStorage.removeItem("crm_auth_token");
    window.location.replace("/crm/login");
    throw new Error("Session expired");
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const d = data.detail;
    throw new Error(Array.isArray(d) ? d.map((x) => x.msg).join(", ") : d || "Request failed");
  }
  return data;
};

export const gbp = (v) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 }).format(v || 0);

export const fmtDate = (iso, withTime = false) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric", ...(withTime ? { hour: "2-digit", minute: "2-digit" } : {}) });
};

export const empName = (e) => (e ? [e.first_name, e.last_name].filter(Boolean).join(" ") : "—");

export const ROLE_LABELS = {
  business_owner: "Business Owner",
  business_admin: "Business Administrator",
  manager: "Manager",
  employee: "Employee",
  sales_user: "Sales User",
};
